import { render, staticRenderFns } from "./risks.vue?vue&type=template&id=37a96f8e"
import script from "./risks.vue?vue&type=script&lang=js"
export * from "./risks.vue?vue&type=script&lang=js"
import style0 from "./risks.vue?vue&type=style&index=0&id=37a96f8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports